import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface TextCellRendererParams extends ICellRendererParams {
	shouldHideDefaultValue?: boolean;
}
@Component({
	selector: 'sh-text-renderer',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './text-renderer.component.html',
	styleUrl: './text-renderer.component.scss'
})
export class TextRendererComponent implements ICellRendererAngularComp {
	public value: string | undefined;

	public agInit(params: TextCellRendererParams): void {
		this.update(params);
	}

	public refresh(params: TextCellRendererParams): boolean {
		this.update(params);
		return true;
	}

	private update(params: TextCellRendererParams): void {
		this.value = params.value ?? (params.shouldHideDefaultValue ? undefined : '--');
	}
}
